import { render, staticRenderFns } from "./LeaveReport.vue?vue&type=template&id=f93fb63a&scoped=true&"
import script from "./LeaveReport.vue?vue&type=script&lang=js&"
export * from "./LeaveReport.vue?vue&type=script&lang=js&"
import style0 from "./LeaveReport.vue?vue&type=style&index=0&id=f93fb63a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93fb63a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VChip,VCol,VDataTable,VIcon,VRow,VSwitch})
